<template>
  <div id="UNBARRING_OTP" class="container-fixed offset-bottom-6">
    <VProgress class="offset-top-2 offset-bottom-2" :steps="steps" active="unbarring.confirmation" />

    <p class="offset-bottom-2 offset-top-2" v-html="$to('unbarring.confirmationDescription')"></p>

    <VForm :form="form" @submit="onNext">
      <VInput name="otp" :label="$t('unbarring.otpLabel')" :hint="$t('errorcodes.WRONG_OTP')" required />

      <div class="offset-top-2 text-right">
        <transition name="fade" mode="out-in" appear>
          <div v-if="isOtpResendDisabled" class="notification notification-negative" role="alert">
            <div class="notification-left">
              <div class="icon-frame">
                <VSvgIcon name="cancel" variant="outlined" size="large" />
              </div>
            </div>
            <div class="notification-content">
              <div class="notification-heading offset-top-1">
                {{ $t('errorcodes.OTP_RESEND_LIMIT_EXCEEDED') }}
              </div>
            </div>
          </div>
        </transition>
        <transition name="fade" mode="out-in" appear>
          <VSpinner v-if="isBusy" slim class="pull-left" />
        </transition>
        <VButton type="button" class="offset-left-1 offset-bottom-1 btn-clean" label="unbarring.abort" @click="redirect" />
        <VButton
          type="button"
          class="offset-left-1 offset-bottom-1 btn-default"
          label="unbarring.otpResendButtonLabel"
          :disabled="isBusy || isOtpResendDisabled"
          @click="onResendOtp"
        />
        <VButton type="submit" class="offset-left-1 offset-bottom-1 btn-default btn-brand" label="unbarring.submit" :disabled="isBusy" />
      </div>
    </VForm>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TitleMixin from '@/mixins/title';
import UnbarringSteps from '@/mixins/unbarringSteps';
import VSpinner from '@/components/Spinner';
import Proxy from '@/proxies/UnbarringProxy';
import VForm from '@/components/Form/Form';
import VInput from '@/components/Form/Input';
import { initFields, focusFirst, focusFirstError, resetValidations, resetValues } from '@/utils/form';
import { UNBARRING_PIN } from '@route-types';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'UnbarringAccess',

  components: {
    VSvgIcon,
    VSpinner,
    VForm,
    VInput,
    VProgress: () => import('@/components/Progress'),
    VButton: () => import('@/components/Button'),
  },

  mixins: [TitleMixin, UnbarringSteps],

  props: {
    isAuthorized: {
      type: Boolean,
      required: false,
    },

    hasPin: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      isBusy: false,
      form: initFields({ name: 'otp' }),
      isOtpResendDisabled: false,
    };
  },

  methods: {
    ...mapActions('unbarring', ['redirect']),

    async onResendOtp() {
      try {
        this.isBusy = true;
        await new Proxy().otpResend();
        resetValues(this.form);
        resetValidations(this.form);
        focusFirst(this.form);
      } catch (error) {
        const code = error?.data?.code;
        if (code === 'OTP_RESEND_LIMIT_EXCEEDED') {
          this.isOtpResendDisabled = true;
        } else {
          throw error;
        }
      } finally {
        this.isBusy = false;
      }
    },

    async onNext({ values }) {
      this.isBusy = true;
      try {
        await new Proxy().otpVerify(values);
        if (!this.hasPin) {
          this.redirect();
        } else {
          this.$router.push({ name: UNBARRING_PIN });
        }
      } catch (error) {
        const code = error?.data?.code;
        if (code === 'WRONG_OTP') {
          this.form.otp.setInvalid();
        } else {
          throw error;
        }
        focusFirstError(this.form);
        this.isBusy = false;
      }
    },
  },
};
</script>
